// extracted by mini-css-extract-plugin
export default {"previewDatasetTable":"DatasetPreviewDialog-module__previewDatasetTable___dpKVy"};